import script from "./PitchDream.vue?vue&type=script&setup=true&lang=js"
export * from "./PitchDream.vue?vue&type=script&setup=true&lang=js"

import "./PitchDream.vue?vue&type=style&index=0&id=01368010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01368010"]])

export default __exports__